import { createStore } from 'vuex'
import { ElMessage } from 'element-plus'
import axios from '../../config-axios'

import sensors from '@/store/modules/sensors'
import company from '@/store/modules/company'
import modem from '@/store/modules/modem'
import user from '@/store/modules/user'

export default createStore({
  modules: {
    sensors,
    company,
    modem,
    user
  },
  state: {
    notifications: [],
  },
  getters: {
    getNotifications(state) {
      return state.notifications
    },
  },
  mutations: {
    setNotifications(state, options) {
      state.notifications = options
    },
  },
  actions: {
    async getNotifications(context) {
      await axios.get('user/notification/').then( response => {
        context.commit('setNotifications', response.data)
      }).catch( error => {
        ElMessage.error('Не удалось получить уведомления')
      })
    },
  }
})
